"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Popover = void 0;
const tslib_1 = require("tslib");
const styled_1 = tslib_1.__importDefault(require("@emotion/styled"));
const react_core_1 = require("@neo-one/react-core");
const popper_js_1 = tslib_1.__importDefault(require("popper.js"));
const React = tslib_1.__importStar(require("react"));
const styled_tools_1 = require("styled-tools");
const Hidden_1 = require("./Hidden");
const PopoverArrow_1 = require("./PopoverArrow");
const { forwardRef, useCallback, useEffect, useRef, useState } = React;
const PopoverComponent = forwardRef((_a, refIn) => {
    var { placement: propPlacement = 'bottom', popoverId, gutter, flip = true, shift = true } = _a, props = tslib_1.__rest(_a, ["placement", "popoverId", "gutter", "flip", "shift"]);
    const myRef = useRef(null);
    const ref = refIn === null ? myRef : refIn;
    const [placement, setPlacement] = useState(propPlacement);
    const [translateX, setTranslateX] = useState(undefined);
    const [translateY, setTranslateY] = useState(undefined);
    const [originX, setOriginX] = useState(undefined);
    const [originY, setOriginY] = useState(undefined);
    const popperRef = useRef(null);
    const modifier = useCallback((data) => {
        const { placement: dataPlacement, offsets, arrowElement, arrowStyles } = data;
        const { reference, popper } = offsets;
        const [position] = dataPlacement.split('-');
        const isVertical = ['top', 'bottom'].indexOf(position) >= 0;
        const referenceCenter = isVertical ? reference.width / 2 : reference.height / 2;
        const side = isVertical ? 'left' : 'top';
        const sideValue = referenceCenter - popper[side];
        if (arrowElement) {
            const { top, left } = arrowStyles;
            arrowElement.style.top = isVertical ? '' : `${top}px`;
            arrowElement.style.left = isVertical ? `${left}px` : '';
        }
        setOriginX(isVertical ? `${sideValue}px - 50%` : 0);
        setOriginY(!isVertical ? `${sideValue}px - 50%` : 0);
        setTranslateX(Math.round(popper.left));
        setTranslateY(Math.round(popper.top));
        setPlacement(data.placement);
        return data;
    }, [setOriginX, setOriginY, setTranslateX, setTranslateY, setPlacement]);
    useEffect(() => {
        const popper = popperRef.current;
        const popover = ref.current;
        if (popper === null && popover !== null && popover.parentNode !== null) {
            const arrow = popover.querySelector(react_core_1.getSelector(PopoverArrow_1.PopoverArrow));
            popperRef.current = new popper_js_1.default(popover.parentNode, popover, {
                placement: propPlacement,
                modifiers: {
                    hide: { enabled: false },
                    applyStyle: { enabled: false },
                    arrow: arrow ? { enabled: !!arrow, element: arrow } : undefined,
                    flip: { enabled: flip, padding: 16 },
                    preventOverflow: {
                        enabled: true,
                        boundariesElement: 'window',
                    },
                    shift: { enabled: shift },
                    offset: { offset: `0, ${gutter}` },
                    setState: {
                        order: 900,
                        enabled: true,
                        fn: modifier,
                    },
                },
            });
        }
        return () => {
            const innerPopper = popperRef.current;
            if (innerPopper !== null) {
                innerPopper.destroy();
                popperRef.current = null;
            }
        };
    }, [props.visible, propPlacement, flip, shift, gutter, props.children, modifier, ref]);
    const defaultPlacement = placement === undefined ? undefined : placement.replace(/-.+$/, '');
    return (React.createElement(Hidden_1.Hidden, Object.assign({ id: popoverId, ref: ref, translateX: translateX, translateY: translateY, originX: originX, originY: originY, "data-placement": placement, defaultSlide: defaultPlacement, defaultExpand: defaultPlacement, slideOffset: gutter }, props, { unmount: false })));
});
exports.Popover = styled_1.default(PopoverComponent) `
  position: absolute;
  top: 0;
  left: 0;
  user-select: auto;
  cursor: auto;
  z-index: 999;
  ${styled_tools_1.theme('Popover')};
`;
exports.Popover.defaultProps = {
    role: 'group',
    placement: 'bottom',
    hideOnEsc: true,
    flip: true,
    shift: true,
    gutter: 12,
    opaque: true,
    palette: 'white',
};

//# sourceMappingURL=Popover.js.map
